






import Vue, { PropType } from 'vue'

import BasePanelSection from 'base/components/BasePanelSection.vue'

import { Widget } from '../widgets/base'
import WidgetPanelSectionItem from './WidgetPanelSectionItem.vue'

export default Vue.extend({
  components: {
    BasePanelSection,
    WidgetPanelSectionItem
  },
  props: {
    header: {
      type: String as PropType<string>,
      required: true
    },
    widgets: {
      type: Array as PropType<Widget[]>
    }
  },
  computed: {
    widgetsList(): any[] {
      return this.widgets.filter((elem) => elem !== null || undefined )
    }
  }
})
